(() => {
  'use strict';
  const core=window.GosGiftCore;
  if(!core || document.documentElement.dataset.gosEnabled!=='true') return;
  const root=window.Shopify?.routes?.root || '/';
  let catalogPromise;
  async function catalog(url,refresh=false) {
    if(refresh) catalogPromise=null;
    if(!catalogPromise) catalogPromise=(async()=>{
      const products=[];
      for(let page=1;page<=20;page++) {
        // JSON Accept selects Shopify's collection API and bypasses the Liquid view.
        const res=await fetch(`${url}&page=${page}`,{headers:{Accept:'text/html'},cache:'no-store'});
        if(!res.ok) throw new Error('Catalogue indisponible. Réessayez dans un instant.');
        const data=await res.json();
        if(!Array.isArray(data.products)||!data.currency) throw new Error('Le catalogue du lot n’a pas pu être chargé.');
        if(data.currency!=='EUR') throw new Error('Cette offre est disponible uniquement en euros.');
        for(const p of data.products) {
          p.variants=p.variants.filter(v=>core.POINTS.includes(v.price));
          if(p.variants.length && !products.some(x=>x.handle===p.handle)) products.push(p);
        }
        if(!data.hasNext) {
          const byId=new Map();
          for(const p of products) for(const v of p.variants) byId.set(v.id,{...v,title:p.title,variantTitle:v.title,handle:p.handle,image:v.image||p.image,url:`${root}products/${p.handle}?variant=${v.id}`});
          return {products,byId};
        }
      }
      throw new Error('Le catalogue doit être vérifié avant de composer ce lot.');
    })().catch(error=>{catalogPromise=null;throw error;});
    return catalogPromise;
  }
  const money=cents=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);
  function node(tag,className,text) {const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el;}
  async function initializeBuilder(module) {
    if(module.dataset.ready) return;
    module.dataset.ready='true';
    const form=module.closest('form'),button=form?.querySelector('[data-add-to-cart]');
    if(!form||!button) return;
    const label=button.querySelector('span')||button;
    const error=module.querySelector('[data-gift-error]');
    const summary=module.querySelector('[data-gift-summary]');
    const rows=module.querySelector('[data-gift-selections]');
    const offers=module.querySelector('[data-gift-offers]');
    let data,choices=[],paid=1,submitting=false,uncertain=false;
    button.disabled=true;
    const fail=message=>{error.textContent=message;error.hidden=!message;};
    const selected=()=>choices.slice(0,core.rule(paid).total).map(id=>data.byId.get(id));
    function refresh() {
      if(!data) return;
      fail('');
      for(const card of module.querySelectorAll('[data-gift-card]')) {
        const count=Number(card.dataset.giftCard);
        card.classList.toggle('is-selected',count===paid);
        const units=choices.slice(0,core.rule(count).total).map(id=>data.byId.get(id));
        try {card.querySelector('[data-gift-card-total]').textContent=money(core.offer(units,count).totalPrice);}
        catch (_) {card.querySelector('[data-gift-card-total]').textContent='À compléter';}
      }
      try {
        const result=core.offer(selected(),paid);
        rows.querySelectorAll('[data-gift-row]').forEach((row,index)=>{
          const free=result.giftIndexes.includes(index),u=selected()[index];
          row.classList.toggle('is-gift',free);
          row.querySelector('[data-gift-role]').textContent=free?'OFFERT':money(u.price);
          const img=row.querySelector('img');img.src=u.image||'';img.alt=u.title;
        });
        summary.textContent=`${result.total} article${result.total>1?'s':''}${result.gifts?` dont ${result.gifts} offert${result.gifts>1?'s':''}`:''} · Total ${money(result.totalPrice)}`;
        label.textContent=`AJOUTER ${result.total} ARTICLE${result.total>1?'S':''} AU PANIER`;
        button.disabled=submitting||uncertain;
      } catch(err) {button.disabled=true;label.textContent='VÉRIFIER LE LOT';summary.textContent='Votre lot doit être complété.';fail(err.message);}
    }
    function renderRows() {
      rows.replaceChildren();
      for(let i=0;i<core.rule(paid).total;i++) {
        const u=data.byId.get(choices[i]);
        const row=node('div','gos-gift-row');row.dataset.giftRow=String(i);
        const img=node('img');img.width=50;img.height=62;img.loading='lazy';row.append(img);
        const controls=node('div','gos-gift-row__choices');
        const heading=node('div','gos-gift-row__heading');heading.append(node('span','',`Article ${i+1}`));
        const role=node('b');role.dataset.giftRole='';heading.append(role);controls.append(heading);
        const productSelect=node('select');productSelect.setAttribute('aria-label',`Produit de l’article ${i+1}`);
        for(const p of data.products) {const opt=new Option(p.title,p.handle);opt.disabled=!p.variants.some(v=>v.available);productSelect.add(opt);}
        productSelect.value=u.handle;controls.append(productSelect);
        const variantSelect=node('select');variantSelect.setAttribute('aria-label',`Variante de l’article ${i+1}`);
        const variants=()=>{
          const p=data.products.find(p=>p.handle===productSelect.value);
          variantSelect.replaceChildren();
          for(const v of p.variants) {const opt=new Option(v.title==='Default Title'?'Format standard':v.title,String(v.id));opt.disabled=!v.available;variantSelect.add(opt);}
          variantSelect.value=String(choices[i]);
          variantSelect.hidden=p.variants.length===1&&p.variants[0].title==='Default Title';
        };
        variants();controls.append(variantSelect);
        productSelect.addEventListener('change',()=>{
          const p=data.products.find(p=>p.handle===productSelect.value);
          choices[i]=(p.variants.find(v=>v.available)||p.variants[0]).id;
          variants();refresh();
        });
        variantSelect.addEventListener('change',()=>{choices[i]=Number(variantSelect.value);refresh();});
        row.append(controls);rows.append(row);
      }
      module.querySelector(`[data-gift-card="${paid}"]`).append(rows);
      rows.hidden=false;refresh();
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(submitting||uncertain||button.disabled||!data) return;
      submitting=true;button.disabled=true;offers.disabled=true;fail('');label.textContent='VÉRIFICATION…';
      try {
        data=await catalog(module.dataset.catalogUrl,true);
        const units=selected();
        const result=core.offer(units,paid);
        const current=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>{if(!r.ok)throw new Error('Impossible de vérifier le panier.');return r.json();});
        // Count previous paid items and gifts against finite inventory as well.
        const committed=new Map();
        const seenGroups=new Set();
        for(const line of current.items) {
          committed.set(line.variant_id,(committed.get(line.variant_id)||0)+line.quantity);
          const group=line.properties?._gos_gift_group;
          if(group&&!seenGroups.has(group)) {
            seenGroups.add(group);
            try {for(const id of JSON.parse(line.properties._gos_gift_plan).giftIds)committed.set(id,(committed.get(id)||0)+1);} catch(_){throw new Error('Vérifiez le lot déjà présent dans votre panier.');}
          }
        }
        for(const u of units) {
          committed.set(u.id,(committed.get(u.id)||0)+1);
          if(Number.isInteger(u.stock)&&committed.get(u.id)>u.stock)throw new Error(`Stock insuffisant : ${u.title}.`);
        }
        const items=core.cartItems(units,paid,crypto.randomUUID());
        label.textContent='AJOUT…';
        // A timeout can occur after Shopify accepts the add. Never repeat it.
        uncertain=true;
        const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!res.ok) {
          const body=await res.json().catch(()=>({}));
          throw new Error(body.description||'Ajout non confirmé. Vérifiez votre panier avant de réessayer.');
        }
        const after=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>r.json());
        if(result.gifts) {
          const group=items[0].properties._gos_gift_group;
          const check=core.validateGroup(after.items.filter(l=>l.properties?._gos_gift_group===group),data.byId);
          if(!check.valid) throw new Error('Vérifiez le lot dans votre panier avant de poursuivre.');
        }
        window.location.assign(document.documentElement.dataset.cartUrl||`${root}cart`);
      } catch(err) {
        submitting=false;
        if(uncertain) {
          label.textContent='VÉRIFIEZ VOTRE PANIER';button.disabled=true;
          fail(err.message+' ');
          const link=node('a','','Ouvrir le panier');link.href=document.documentElement.dataset.cartUrl||`${root}cart`;error.append(link);
        } else {offers.disabled=false;refresh();fail(err.message);}
      }
    });
    try {
      data=await catalog(module.dataset.catalogUrl);
      const initial=data.byId.get(Number(module.dataset.variantId));
      if(!initial) throw new Error('Ce produit ne participe pas aux lots avec cadeaux.');
      choices=Array(7).fill(initial.id);
      // The bundle controls own variant selection once the catalogue is ready.
      for(const control of form.querySelectorAll('[data-variant-select], .product-options, .reference-product-options')) control.hidden=true;
      offers.disabled=false;
      for(const radio of module.querySelectorAll('[data-gift-offer]')) radio.addEventListener('change',()=>{if(radio.checked){paid=Number(radio.value);renderRows();}});
      module.closest('[data-product-section]')?.addEventListener('variant:change',event=>{
        const id=Number(event.detail?.variant?.id);
        if(data.byId.has(id)) {choices=choices.map(old=>data.byId.get(old)?.handle===module.dataset.productHandle?id:old);renderRows();}
      });
      renderRows();
    } catch(err) {summary.textContent='Le lot ne peut pas être chargé.';fail(err.message);label.textContent='LOT INDISPONIBLE';button.disabled=true;}
  }
  async function initializeCart(form) {
    if(form.dataset.giftReady) return;
    form.dataset.giftReady='true';
    const script=form.querySelector('[data-gift-cart-data]');
    if(!script) return;
    const checkout=form.querySelector('[name="checkout"]');
    const status=form.querySelector('[data-gift-cart-status]');
    const catalogURL=form.dataset.giftCatalogUrl;
    const showError=message=>{status.textContent=message;status.hidden=!message;if(checkout)checkout.disabled=Boolean(message);};
    let checking=false,allowSubmit=false;
    function check(items,data,render=false) {
      const groups=new Map();
      for(const line of items) if(line.properties?._gos_gift_group) {
        const key=line.properties._gos_gift_group;
        if(!groups.has(key))groups.set(key,[]);groups.get(key).push(line);
      }
      for(const [group,lines] of groups) {
        const result=core.validateGroup(lines,data.byId);
        if(!result.valid)throw new Error(result.message);
        if(render) {
          const block=node('aside','gos-cart-gifts');block.setAttribute('aria-label','Produits offerts');
          block.append(node('strong','',`${result.gifts} cadeau${result.gifts>1?'x':''} inclus dans ce lot`));
          const list=node('ul');
          for(const u of result.giftUnits) {
            const li=node('li'),img=node('img');img.src=u.image||'';img.alt=u.title;img.width=54;img.height=62;img.loading='lazy';
            const link=node('a','',u.title);link.href=u.url;
            if(u.variantTitle!=='Default Title')link.append(node('small','',u.variantTitle));
            li.append(img,link,node('b','','OFFERT'));list.append(li);
          }
          block.append(list,node('small','','Cadeaux inclus dans le lot, sans montant supplémentaire.'));
          const elements=[...form.querySelectorAll('[data-gift-cart-group]')].filter(el=>el.dataset.giftCartGroup===group);
          elements.at(-1)?.after(block);
        }
      }
      const required=new Map();
      for(const line of items)required.set(line.variant_id,(required.get(line.variant_id)||0)+line.quantity);
      for(const lines of groups.values())for(const id of JSON.parse(lines[0].properties._gos_gift_plan).giftIds)required.set(id,(required.get(id)||0)+1);
      for(const [id,count] of required) {
        const u=data.byId.get(id);
        if(u&&Number.isInteger(u.stock)&&count>u.stock)throw new Error(`Stock insuffisant : ${u.title}. Recomposez le lot.`);
      }
    }
    for(const remove of form.querySelectorAll('[data-gift-remove]')) remove.addEventListener('click',async()=>{
      if(checking)return;checking=true;remove.disabled=true;if(checkout)checkout.disabled=true;
      try {
        const cart=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>r.json());
        const updates={};for(const line of cart.items)if(line.properties?._gos_gift_group===remove.dataset.giftRemove)updates[line.key]=0;
        const res=await fetch(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
        if(!res.ok)throw new Error('Suppression non confirmée. Rechargez votre panier.');
        window.location.reload();
      } catch(err){showError(err.message);checking=false;remove.disabled=false;}
    });
    form.addEventListener('submit',async event=>{
      if(event.submitter?.name!=='checkout'||allowSubmit)return;
      event.preventDefault();event.stopImmediatePropagation();if(checking)return;
      checking=true;if(checkout)checkout.disabled=true;
      try {
        const data=await catalog(catalogURL,true);
        const cart=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>{if(!r.ok)throw new Error('Panier indisponible.');return r.json();});
        check(cart.items,data);
        allowSubmit=true;showError('');form.requestSubmit(event.submitter);
      } catch(err){showError(err.message);checking=false;}
    },true);
    try {const data=await catalog(catalogURL);check(JSON.parse(script.textContent),data,true);showError('');}
    catch(err){showError(err.message);}
  }
  const initialize=scope=>{
    scope.querySelectorAll('[data-gos-gift-builder]').forEach(initializeBuilder);
    scope.querySelectorAll('[data-gift-cart]').forEach(initializeCart);
  };
  document.addEventListener('DOMContentLoaded',()=>initialize(document));
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
